// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file player_bay_session.proto (package evenplay.bay_session.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PlayerStateUpdateSchema, SessionStateUpdateSchema } from "./bay_session_pb";
import { file_bay_session } from "./bay_session_pb";
import type { AckMessageRequestSchema, AckMessageResponseSchema, GetBetDetailsRequestSchema, GetBetDetailsResponseSchema, GetSessionStateRequestSchema, GetSessionStateResponseSchema, LeaveSessionRequestSchema, LeaveSessionResponseSchema, SessionPlayer, SessionState, SetNextWagerCurrencyRequestSchema, SetNextWagerCurrencyResponseSchema, SetPlayerConfirmationSettingsRequestSchema, SetPlayerConfirmationSettingsResponseSchema, StreamSessionStateRequestSchema, SwitchWagerCurrencyRequestSchema, SwitchWagerCurrencyResponseSchema, WagerMode } from "./bay_session_shared_pb";
import { file_bay_session_shared } from "./bay_session_shared_pb";
import type { CreatePrivateTournamentReplySchema, CreatePrivateTournamentRequestSchema, GetTournamentLeaderBoardReplySchema, GetTournamentLeaderBoardRequestSchema, GetTournamentPlayersReplySchema, GetTournamentPlayersRequestSchema, GetTournamentPrizeDistributionReplySchema, GetTournamentPrizeDistributionRequestSchema, GetTournamentReplySchema, GetTournamentRequestSchema, GetTournamentScheduleReplySchema, GetTournamentScheduleRequestSchema, JoinPrivateTournamentReplySchema, JoinPrivateTournamentRequestSchema, JoinTournamentReplySchema, JoinTournamentRequestSchema, LeaveTournamentReplySchema, LeaveTournamentRequestSchema, ListDefaultTournamentReplySchema, ListDefaultTournamentRequestSchema, ListTournamentReplySchema, ListTournamentRequestSchema, StreamTournamentUpdatesReplySchema, StreamTournamentUpdatesRequestSchema, VerifyPrivateTournamentCodeReplySchema, VerifyPrivateTournamentCodeRequestSchema } from "./tournament_bay_session_pb";
import { file_tournament_bay_session } from "./tournament_bay_session_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file player_bay_session.proto.
 */
export const file_player_bay_session: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bay_session, file_bay_session_shared, file_tournament_bay_session]);

/**
 * @generated from message evenplay.bay_session.v1.JoinSessionRequest
 */
export type JoinSessionRequest = Message<"evenplay.bay_session.v1.JoinSessionRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * NONE = use venue default
   *
   * @generated from field: evenplay.bay_session.v1.WagerMode initial_wager_mode = 2;
   */
  initialWagerMode: WagerMode;

  /**
   * skip mobile confirmation for this session
   *
   * @generated from field: bool bypass_confirmation = 3;
   */
  bypassConfirmation: boolean;

  /**
   * Cold-start confirmation (SMG-2363). Present only when the join answers an
   * "Is this you at Bay N?" CONFIRMATION message: the player was recognised
   * at an unassigned FRS bay, a proposal was recorded, and this is their
   * phone-side confirmation. bay-session validates the proposal (PENDING,
   * unexpired, owned by the caller, for this station) and runs a 1:1
   * COLD_START-purpose face verification against cloud FRS BEFORE the
   * ordinary join runs; a failed verification rejects the whole request.
   * Absent for every ordinary join.
   *
   * @generated from field: evenplay.bay_session.v1.ColdStartConfirmation cold_start = 4;
   */
  coldStart?: ColdStartConfirmation;
};

/**
 * Describes the message evenplay.bay_session.v1.JoinSessionRequest.
 * Use `create(JoinSessionRequestSchema)` to create a new message.
 */
export const JoinSessionRequestSchema: GenMessage<JoinSessionRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 0);

/**
 * ColdStartConfirmation — the player's answer to a cold-start proposal
 * (SMG-2363). Both fields are required when the message is present.
 *
 * @generated from message evenplay.bay_session.v1.ColdStartConfirmation
 */
export type ColdStartConfirmation = Message<"evenplay.bay_session.v1.ColdStartConfirmation"> & {
  /**
   * The proposal being confirmed: the UUID carried as the CONFIRMATION
   * message's message_id and in its rich_payload.proposal_id.
   *
   * @generated from field: string proposal_id = 1;
   */
  proposalId: string;

  /**
   * Presigned URL of a selfie captured on the confirming phone, verified 1:1
   * against the caller's VERIFIED enrolments at the COLD_START threshold.
   * This is the "prove the confirming phone belongs to the detected face"
   * half of the confirmation; possession of the account session is the other.
   *
   * @generated from field: string verification_image_url = 2;
   */
  verificationImageUrl: string;
};

/**
 * Describes the message evenplay.bay_session.v1.ColdStartConfirmation.
 * Use `create(ColdStartConfirmationSchema)` to create a new message.
 */
export const ColdStartConfirmationSchema: GenMessage<ColdStartConfirmation> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 1);

/**
 * @generated from message evenplay.bay_session.v1.JoinSessionResponse
 */
export type JoinSessionResponse = Message<"evenplay.bay_session.v1.JoinSessionResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 1;
   */
  player?: SessionPlayer;

  /**
   * @generated from field: evenplay.bay_session.v1.SessionState session = 2;
   */
  session?: SessionState;

  /**
   * @generated from field: bool first_session_credit_granted = 3;
   */
  firstSessionCreditGranted: boolean;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.WalletCredit first_session_credits = 4;
   */
  firstSessionCredits: WalletCredit[];
};

/**
 * Describes the message evenplay.bay_session.v1.JoinSessionResponse.
 * Use `create(JoinSessionResponseSchema)` to create a new message.
 */
export const JoinSessionResponseSchema: GenMessage<JoinSessionResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 2);

/**
 * @generated from message evenplay.bay_session.v1.WalletCredit
 */
export type WalletCredit = Message<"evenplay.bay_session.v1.WalletCredit"> & {
  /**
   * @generated from field: string currency = 1;
   */
  currency: string;

  /**
   * cents or points
   *
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.WalletCredit.
 * Use `create(WalletCreditSchema)` to create a new message.
 */
export const WalletCreditSchema: GenMessage<WalletCredit> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 3);

/**
 * AcceptBetRequest — see spec §12.3 + §15.5 + §2.4.
 *
 * @generated from message evenplay.bay_session.v1.AcceptBetRequest
 */
export type AcceptBetRequest = Message<"evenplay.bay_session.v1.AcceptBetRequest"> & {
  /**
   * Station hosting the player. Used for authorization + currency-set
   * resolution (effective_currencies for the station's venue + partner).
   *
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * The challenge the player is wagering on. The challenge owns the
   * target distance / multiplier / max-amount limits that the bet
   * amount is validated against. Bay-session does not own challenge
   * state; the field is recorded on smg_bet as bet_type/priority
   * metadata so downstream handlers (StartHit / ProcessShot) can
   * correlate to the engine's pre-generated challenge row.
   *
   * @generated from field: int64 challenge_id = 2;
   */
  challengeId: bigint;

  /**
   * Wager amount in minor units of currency (cents for fiat, 1:1 for
   * points). Must be > 0. Bay-session enforces ONLY the positivity
   * check at AcceptBet. Min/max bet-limit enforcement against the
   * challenge's authoritative bounds is NOT performed downstream
   * either — neither the StartHit debit nor the wallet currently
   * validates bet-amount-range. Tracked as BSA-5-2-FU3 to wire
   * bet-amount-range enforcement into AcceptBet so semantically
   * invalid wagers are rejected at acceptance. Until FU3 lands,
   * callers must not assume any range validation.
   *
   * @generated from field: int64 bet_amount = 3;
   */
  betAmount: bigint;

  /**
   * Currency selected at challenge time (spec §11.5). Codes: "USD",
   * "TGP", "FSP", "TGPTS", "FSPTS", "PRACTICE" — the wallet
   * identifier. SMG-3087 (2026-06-04): currency is the wallet
   * identifier; wager_mode is the user-visible CATEGORY (MONEY /
   * POINTS / PRACTICE) — see bay_session_shared.proto.WagerMode.
   * Bay-session enforces ONLY the literal vocabulary at AcceptBet.
   * The player's offered-set enforcement
   * (existing wallet currencies ∩ station effective_currencies) is
   * NOT performed downstream either: AcceptBet eagerly auto-creates
   * the wallet for the requested currency BEFORE the smg_bet INSERT,
   * so "player has no wallet for this currency" is never the failure
   * mode at StartHit — the wallet always exists by then. Tracked as
   * BSA-5-2-FU3 to wire offered-set enforcement against
   * bay_session_players.next_wager_currency + station
   * effective_currencies. Until FU3 lands, callers must not assume
   * any offered-set rejection.
   *
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * Client-supplied idempotency key (UUID v4 string). Optional during
   * the FullSwing 90-day compat window: when empty, the server derives
   * a deterministic fallback key from the canonical request body so
   * legacy-client retries of the same request still hit the dedup
   * path. Required at day 90 (post-compat-window, an empty key
   * returns CodeInvalidArgument). When supplied, the version field
   * MUST be 4 — the server rejects v1/v3/v5.
   *
   * @generated from field: string accept_idempotency_key = 6;
   */
  acceptIdempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.AcceptBetRequest.
 * Use `create(AcceptBetRequestSchema)` to create a new message.
 */
export const AcceptBetRequestSchema: GenMessage<AcceptBetRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 4);

/**
 * @generated from message evenplay.bay_session.v1.AcceptBetResponse
 */
export type AcceptBetResponse = Message<"evenplay.bay_session.v1.AcceptBetResponse"> & {
  /**
   * Server-assigned smg_bet.bet_id (string-form of the int64 PK for
   * wire stability across the future int64->UUID migration).
   *
   * @generated from field: string bet_id = 1;
   */
  betId: string;

  /**
   * The bet's persisted state. Always 'accepted' on first-write success;
   * also 'accepted' on a duplicate-key replay (same hash). On a replay
   * after a CancelBet the state may be 'refunded' so the client can
   * detect that a fresh bet must be created with a new idempotency key.
   *
   * @generated from field: string bet_state = 2;
   */
  betState: string;

  /**
   * Echo of the persisted currency for client correlation.
   *
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * Echo of the persisted bet amount.
   *
   * @generated from field: int64 bet_amount = 4;
   */
  betAmount: bigint;

  /**
   * Whether this response is the result of an idempotency-replay
   * (true) or a fresh insert (false). Surfaces the dedup path so
   * clients can correlate retries in logs.
   *
   * @generated from field: bool was_idempotent_replay = 5;
   */
  wasIdempotentReplay: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.AcceptBetResponse.
 * Use `create(AcceptBetResponseSchema)` to create a new message.
 */
export const AcceptBetResponseSchema: GenMessage<AcceptBetResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 5);

/**
 * StreamPlayerStateRequest — per-user push subscription. The token's
 * user_id is the subscription's user_id; the predicate enforces that
 * (RequirePlayerSelf).
 *
 * @generated from message evenplay.bay_session.v1.StreamPlayerStateRequest
 */
export type StreamPlayerStateRequest = Message<"evenplay.bay_session.v1.StreamPlayerStateRequest"> & {
  /**
   * optional; 0 = full snapshot
   *
   * @generated from field: int64 since_sequence = 1;
   */
  sinceSequence: bigint;

  /**
   * since_db_version — same semantics as
   * StreamSessionStateRequest.since_db_version (BSA-FU-PANEL-XPOD-2).
   * Clients that track PlayerStateUpdate.db_version should echo the
   * last value they delivered to the app on reconnect; omitting it
   * forces the server back through a fresh snapshot.
   *
   * @generated from field: int64 since_db_version = 2;
   */
  sinceDbVersion: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.StreamPlayerStateRequest.
 * Use `create(StreamPlayerStateRequestSchema)` to create a new message.
 */
export const StreamPlayerStateRequestSchema: GenMessage<StreamPlayerStateRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 6);

/**
 * @generated from message evenplay.bay_session.v1.RespondToConfirmationRequest
 */
export type RespondToConfirmationRequest = Message<"evenplay.bay_session.v1.RespondToConfirmationRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: bool accepted = 2;
   */
  accepted: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.RespondToConfirmationRequest.
 * Use `create(RespondToConfirmationRequestSchema)` to create a new message.
 */
export const RespondToConfirmationRequestSchema: GenMessage<RespondToConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 7);

/**
 * @generated from message evenplay.bay_session.v1.RespondToConfirmationResponse
 */
export type RespondToConfirmationResponse = Message<"evenplay.bay_session.v1.RespondToConfirmationResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionState session = 1;
   */
  session?: SessionState;
};

/**
 * Describes the message evenplay.bay_session.v1.RespondToConfirmationResponse.
 * Use `create(RespondToConfirmationResponseSchema)` to create a new message.
 */
export const RespondToConfirmationResponseSchema: GenMessage<RespondToConfirmationResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 8);

/**
 * @generated from message evenplay.bay_session.v1.SkipMyTurnRequest
 */
export type SkipMyTurnRequest = Message<"evenplay.bay_session.v1.SkipMyTurnRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.SkipMyTurnRequest.
 * Use `create(SkipMyTurnRequestSchema)` to create a new message.
 */
export const SkipMyTurnRequestSchema: GenMessage<SkipMyTurnRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 9);

/**
 * @generated from message evenplay.bay_session.v1.SkipMyTurnResponse
 */
export type SkipMyTurnResponse = Message<"evenplay.bay_session.v1.SkipMyTurnResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionState session = 1;
   */
  session?: SessionState;
};

/**
 * Describes the message evenplay.bay_session.v1.SkipMyTurnResponse.
 * Use `create(SkipMyTurnResponseSchema)` to create a new message.
 */
export const SkipMyTurnResponseSchema: GenMessage<SkipMyTurnResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 10);

/**
 * SetWagerModeRequest carries the station the caller is in and the
 * wager_mode they want their bay_session_players row updated to. No
 * user_id field — the target user is always the caller (the player
 * JWT carries it).
 *
 * @generated from message evenplay.bay_session.v1.SetWagerModeRequest
 */
export type SetWagerModeRequest = Message<"evenplay.bay_session.v1.SetWagerModeRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: evenplay.bay_session.v1.WagerMode wager_mode = 2;
   */
  wagerMode: WagerMode;
};

/**
 * Describes the message evenplay.bay_session.v1.SetWagerModeRequest.
 * Use `create(SetWagerModeRequestSchema)` to create a new message.
 */
export const SetWagerModeRequestSchema: GenMessage<SetWagerModeRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 11);

/**
 * SetWagerModeResponse returns the updated SessionPlayer snapshot and
 * the containing SessionState. SessionState is surfaced so a caller
 * that only needs the post-write snapshot avoids a second
 * GetSessionState round-trip.
 *
 * @generated from message evenplay.bay_session.v1.SetWagerModeResponse
 */
export type SetWagerModeResponse = Message<"evenplay.bay_session.v1.SetWagerModeResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 1;
   */
  player?: SessionPlayer;

  /**
   * @generated from field: evenplay.bay_session.v1.SessionState session = 2;
   */
  session?: SessionState;
};

/**
 * Describes the message evenplay.bay_session.v1.SetWagerModeResponse.
 * Use `create(SetWagerModeResponseSchema)` to create a new message.
 */
export const SetWagerModeResponseSchema: GenMessage<SetWagerModeResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 12);

/**
 * SetAutoContinueRequest toggles the caller's autoplay flag at a
 * station. See the RPC docstring on PlayerBaySessionService for the
 * full semantics (idempotency, wager_cents=0 = leave untouched).
 *
 * @generated from message evenplay.bay_session.v1.SetAutoContinueRequest
 */
export type SetAutoContinueRequest = Message<"evenplay.bay_session.v1.SetAutoContinueRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * wager_cents pins the per-user autoplay amount when > 0; pass 0
   * to leave the existing per-user amount in place. Negative values
   * are rejected with CodeInvalidArgument.
   *
   * @generated from field: int64 wager_cents = 3;
   */
  wagerCents: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.SetAutoContinueRequest.
 * Use `create(SetAutoContinueRequestSchema)` to create a new message.
 */
export const SetAutoContinueRequestSchema: GenMessage<SetAutoContinueRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 13);

/**
 * SetAutoContinueResponse returns the post-write SessionPlayer
 * snapshot (carrying the new auto_continue_* fields) plus the
 * containing SessionState so the caller can refresh its UI without
 * a second GetSessionState round-trip.
 *
 * @generated from message evenplay.bay_session.v1.SetAutoContinueResponse
 */
export type SetAutoContinueResponse = Message<"evenplay.bay_session.v1.SetAutoContinueResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 1;
   */
  player?: SessionPlayer;

  /**
   * @generated from field: evenplay.bay_session.v1.SessionState session = 2;
   */
  session?: SessionState;
};

/**
 * Describes the message evenplay.bay_session.v1.SetAutoContinueResponse.
 * Use `create(SetAutoContinueResponseSchema)` to create a new message.
 */
export const SetAutoContinueResponseSchema: GenMessage<SetAutoContinueResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 14);

/**
 * CancelBetRequest — see spec §2.4 + §15.
 *
 * @generated from message evenplay.bay_session.v1.CancelBetRequest
 */
export type CancelBetRequest = Message<"evenplay.bay_session.v1.CancelBetRequest"> & {
  /**
   * Server-assigned smg_bet.bet_id (string-form of the int64 PK,
   * matching AcceptBetResponse.bet_id for wire stability across the
   * future int64→UUID migration). The handler parses this back to
   * int64 for the lookup; an invalid (non-numeric) value is rejected
   * with CodeInvalidArgument.
   *
   * @generated from field: string bet_id = 1;
   */
  betId: string;

  /**
   * Client-supplied idempotency key (UUID v4). REQUIRED — CancelBet
   * does NOT have the FullSwing 90-day compat-mode escape that
   * AcceptBet has (CancelBet did not exist before the BSA cutover,
   * so no legacy client calls it without a key). When supplied, the
   * version field MUST be 4 — the server rejects v1/v3/v5.
   *
   * The key is informational at the wire surface — the canonical
   * dedupe is the bet row's bet_state + refund_reason. A retry with
   * the same (bet_id, key) returns the existing refund response.
   *
   * @generated from field: string idempotency_key = 2;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.CancelBetRequest.
 * Use `create(CancelBetRequestSchema)` to create a new message.
 */
export const CancelBetRequestSchema: GenMessage<CancelBetRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 15);

/**
 * @generated from message evenplay.bay_session.v1.CancelBetResponse
 */
export type CancelBetResponse = Message<"evenplay.bay_session.v1.CancelBetResponse"> & {
  /**
   * Server-assigned smg_bet.bet_id (string-form of the int64 PK)
   * echoed back so the client can correlate retries.
   *
   * @generated from field: string bet_id = 1;
   */
  betId: string;

  /**
   * Refunded amount in minor units of the bet's currency. Equal to
   * smg_bet.amount; surfaced so the client doesn't need a second
   * round-trip to confirm what was rolled back.
   *
   * @generated from field: int64 refunded_amount = 2;
   */
  refundedAmount: bigint;

  /**
   * The bet's currency code, echoed from smg_bet for client
   * correlation.
   *
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * The bet's terminal state — always 'refunded' on success; useful
   * for client-side logging and reconciliation.
   *
   * @generated from field: string bet_state = 4;
   */
  betState: string;

  /**
   * The refund_reason persisted on the bet row. Always 'player_cancelled'
   * on a CancelBet-initiated refund; surfaced so a future replay
   * could detect that an existing refund came from this RPC versus
   * a non-player-cancel source.
   *
   * @generated from field: string refund_reason = 5;
   */
  refundReason: string;

  /**
   * Whether this response is the result of an idempotency replay
   * (true) or a fresh cancellation (false). Surfaces the dedupe path
   * so clients can correlate retries in logs.
   *
   * @generated from field: bool was_idempotent_replay = 6;
   */
  wasIdempotentReplay: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.CancelBetResponse.
 * Use `create(CancelBetResponseSchema)` to create a new message.
 */
export const CancelBetResponseSchema: GenMessage<CancelBetResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 16);

/**
 * ResizeWagerRequest — see SMG-3140 v1.1 B4. The (caller_user_id,
 * station_id, currency) tuple identifies the wager row to resize; the
 * caller_user_id is derived server-side from the player JWT (the
 * predicate is RequirePlayerSelf). No bet_id field — the wager substrate's
 * natural PK is (user, station, currency), and the lookup runs against
 * bay_session_wagers, not smg_bet.
 *
 * @generated from message evenplay.bay_session.v1.ResizeWagerRequest
 */
export type ResizeWagerRequest = Message<"evenplay.bay_session.v1.ResizeWagerRequest"> & {
  /**
   * Station hosting the wager (matches bay_session_wagers.station_id).
   *
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * Currency identifying the wager row to resize (matches
   * bay_session_wagers.currency). Tokens are UPPERCASE per the
   * smg_bet.currency convention (USD / TGP / FSP / TGPTS / FSPTS /
   * PRACTICE); the handler normalises the input to upper-case before
   * the lookup.
   *
   * @generated from field: string currency = 2;
   */
  currency: string;

  /**
   * New wager amount in minor units of the currency. Must be > 0
   * (a zero amount would be a CancelBet, not a resize). The handler
   * updates both bay_session_wagers.amount and smg_bet.amount inside
   * one MutateStation tx; the wallet sees the new amount when
   * StartHit's ConfirmDebit fires (no wallet RPC is made during
   * ResizeWager — see the RPC docstring).
   *
   * @generated from field: int64 new_amount = 3;
   */
  newAmount: bigint;

  /**
   * Client-supplied idempotency key (UUID v4). OPTIONAL (SMG-3488):
   * ResizeWager sets an ABSOLUTE amount and makes no wallet call, so it is
   * naturally idempotent and the key guards a side-effect that does not
   * exist. An empty key is accepted. When a key IS supplied its version
   * field MUST be 4 (the server rejects v1/v3/v5 to keep the dedupe surface
   * tight) and it is recorded on the matched-route wager row's
   * resize_idempotency_key column purely as an audit breadcrumb. The key no
   * longer gates a second resize — multiple resizes are allowed with
   * last-write-wins. See the RPC docstring for the full contract.
   *
   * @generated from field: string idempotency_key = 4;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.ResizeWagerRequest.
 * Use `create(ResizeWagerRequestSchema)` to create a new message.
 */
export const ResizeWagerRequestSchema: GenMessage<ResizeWagerRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 17);

/**
 * @generated from message evenplay.bay_session.v1.ResizeWagerResponse
 */
export type ResizeWagerResponse = Message<"evenplay.bay_session.v1.ResizeWagerResponse"> & {
  /**
   * The wager amount before the resize. Echo of bay_session_wagers.amount
   * as it was prior to the UPDATE; on an idempotent replay this is the
   * PRE-resize amount that the original call observed.
   *
   * @generated from field: int64 previous_amount = 1;
   */
  previousAmount: bigint;

  /**
   * The wager amount after the resize. Echo of bay_session_wagers.amount
   * post-UPDATE; on an idempotent no-op (new_amount == previous_amount)
   * this equals previous_amount.
   *
   * @generated from field: int64 new_amount = 2;
   */
  newAmount: bigint;

  /**
   * The wager's currency, echoed for client correlation.
   *
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * Retained for wire compatibility. SMG-3488 removed replay caching
   * (resizes are last-write-wins with an optional key), so this is now
   * ALWAYS false — every resize is treated as a fresh absolute SET. Do not
   * gate client logic on this field.
   *
   * @generated from field: bool was_idempotent_replay = 4;
   */
  wasIdempotentReplay: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.ResizeWagerResponse.
 * Use `create(ResizeWagerResponseSchema)` to create a new message.
 */
export const ResizeWagerResponseSchema: GenMessage<ResizeWagerResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 18);

/**
 * FullSwingAuthRequest — request body for the FullSwingAuth RPC. The
 * FullSwing JWT travels in the body field (NOT the Authorization
 * header) so the player-listener's authz interceptor (which expects
 * evenplay-issued tokens) does not reject the inbound request. The
 * handler runs its own JWKS-backed verification on `fullswing_jwt`
 * before issuing an evenplay player JWT.
 *
 * @generated from message evenplay.bay_session.v1.FullSwingAuthRequest
 */
export type FullSwingAuthRequest = Message<"evenplay.bay_session.v1.FullSwingAuthRequest"> & {
  /**
   * Bearer JWT issued by FullSwing's Cognito User Pool. RS256 with a
   * kid header. Verified against the FullSwing JWKS endpoint.
   *
   * @generated from field: string fullswing_jwt = 1;
   */
  fullswingJwt: string;

  /**
   * The FullSwing session_id (opaque string). Used to resolve the
   * fs_station_session row to a station_id for the implicit check-in.
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * Optional. Controls the returned redirect_target. Recognised values:
   *   "" / unset / "challenges" -> "challenges"
   *   "tournament"              -> "tournaments"
   * Unknown non-empty values default to "challenges".
   *
   * @generated from field: string promo_type = 3;
   */
  promoType: string;
};

/**
 * Describes the message evenplay.bay_session.v1.FullSwingAuthRequest.
 * Use `create(FullSwingAuthRequestSchema)` to create a new message.
 */
export const FullSwingAuthRequestSchema: GenMessage<FullSwingAuthRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 19);

/**
 * FullSwingAuthResponse — handler output. Carries the freshly-minted
 * evenplay player JWT, the resolved smg_user.user_id, the user's TnC
 * flag (so the client can route to the T&C flow), and the redirect
 * target the client should navigate to after auth.
 *
 * Fields 5-8 (SMG-3012 / SMG-3009): on top of the bay-session player
 * JWT (field 1), the handler now also mints + returns the smg-core
 * session token that smgClient.* RPCs (GetUser, GetBalance,
 * EnableAutoPlay, the legacy AcceptBet path, etc.) validate against.
 * Without these the client would have to call partner-service's
 * FullSwingTokenLogin separately to get a smg-core-validated token,
 * which is exactly the reliance this migration removes.
 *
 * The smg_session_token + User-shape fields are sourced from smg-core's
 * InternalApiService.LoginUser RPC (same call partner-service's
 * FullSwingTokenLogin makes). The bay-session handler bridges to that
 * RPC after resolving smg_user.user_id so the post-auth client state
 * matches partner-service's existing FullSwingTokenLoginReply shape.
 *
 * @generated from message evenplay.bay_session.v1.FullSwingAuthResponse
 */
export type FullSwingAuthResponse = Message<"evenplay.bay_session.v1.FullSwingAuthResponse"> & {
  /**
   * Freshly-minted evenplay player JWT (HS256, AuthMethod="fullswing",
   * KYCStatus=0). Caller forwards this on subsequent BaySessionService
   * RPCs in the Authorization: Bearer header.
   *
   * @generated from field: string evenplay_jwt = 1;
   */
  evenplayJwt: string;

  /**
   * The resolved smg_user.user_id as a decimal string. Surfaced so the
   * client can correlate without re-decoding the JWT.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * Snapshot of smg_user_details.tnc_accepted at handler-run time. The
   * client routes to the T&C flow when false.
   *
   * @generated from field: bool tnc_accepted = 3;
   */
  tncAccepted: boolean;

  /**
   * Where the client should navigate after auth. Computed from
   * promo_type per the request comment.
   *
   * @generated from field: string redirect_target = 4;
   */
  redirectTarget: string;

  /**
   * smg-core-issued session token. Validates against smg-core's
   * smg_user_session table; used by the client for every smgClient.*
   * RPC (GetUser / GetBalance / EnableAutoPlay / legacy AcceptBet /
   * HitSingle / StartHit). The bay-session handler obtains this by
   * calling smg-core's InternalApiService.LoginUser internally after
   * resolving smg_user.user_id.
   *
   * Empty IFF smg-core was unreachable at handler-run time AND the
   * handler did not fail the response (degraded-mode dev environments);
   * production callers MUST treat empty as a hard auth failure and
   * surface "session not available, please retry" to the user.
   *
   * @generated from field: string smg_session_token = 5;
   */
  smgSessionToken: string;

  /**
   * User-shape fields the client needs immediately post-auth.
   * Mirrors smg.User.firstname / lastname / date_of_birth (the < 18
   * age check on the client reads date_of_birth before completing the
   * login flow). Pulled from smg-core's LoginUser reply.
   *
   * @generated from field: string first_name = 6;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 7;
   */
  lastName: string;

  /**
   * YYYY-MM-DD; empty when smg-core has no value
   *
   * @generated from field: string date_of_birth = 8;
   */
  dateOfBirth: string;

  /**
   * Snapshot of smg_user_details.kyc_status surfaced via smg-core's
   * LoginUser reply (qb.smg.User.kyc_status, field 20). Values:
   *   0 = not attempted
   *   1 = passed
   *   2 = failed
   *
   * Combined with date_of_birth, this lets the mobile (and any other
   * consumer) derive the player's UserTier per the partner-eligibility
   * model documented in docs/partners/integration.md section 2:
   *
   *   age <  13              -> GUEST
   *   age 13..17             -> MINOR
   *   age >= 18, kyc_status=0 -> ADULT_UNCONFIRMED
   *   age >= 18, kyc_status=1 -> ADULT_KYC_VALIDATED
   *   age >= 18, kyc_status=2 -> ADULT_KYC_FAILED
   *
   * The bay-session server side maintains the same derivation in
   * apps/platform-domain/bay-session/internal/eligibility/tier.go;
   * SMG-3076 will land the corresponding allowed_wager_modes field on
   * SessionPlayer so consumers do not have to recompute the tier x
   * jurisdiction intersection themselves.
   *
   * Out-of-vocabulary numeric values (anything not in {0,1,2}) are
   * collapsed by the server-side tier helper to "not attempted" — a
   * defensive narrowing so an unknown status cannot silently grant
   * wager privileges the user has not earned.
   *
   * @generated from field: int32 kyc_status = 9;
   */
  kycStatus: number;
};

/**
 * Describes the message evenplay.bay_session.v1.FullSwingAuthResponse.
 * Use `create(FullSwingAuthResponseSchema)` to create a new message.
 */
export const FullSwingAuthResponseSchema: GenMessage<FullSwingAuthResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 20);

/**
 * SetAccountLockRequest — toggle the caller's persistent kiosk-
 * walkaway-protection opt-in. The target user is always the caller
 * (the player JWT carries it); no user_id field on the request.
 *
 * @generated from message evenplay.bay_session.v1.SetAccountLockRequest
 */
export type SetAccountLockRequest = Message<"evenplay.bay_session.v1.SetAccountLockRequest"> & {
  /**
   * Desired terminal state of smg_user_details.locked. TRUE engages
   * the lock (and seeds bay_session_players.lock_status=USER_LOCKED
   * on every active per-station row); FALSE clears the lock (and
   * seeds bay_session_players.lock_status=ACTIVE).
   *
   * @generated from field: bool locked = 1;
   */
  locked: boolean;

  /**
   * Client-supplied idempotency key (UUID v4 string). Optional. When
   * supplied, the version field MUST be 4 — the server rejects
   * v1/v3/v5 with CodeInvalidArgument. The canonical dedupe is the
   * post-condition (current state already matches); the key is
   * informational and NOT persisted. Same-state retries collapse to
   * the no-op short-circuit.
   *
   * @generated from field: string idempotency_key = 2;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.SetAccountLockRequest.
 * Use `create(SetAccountLockRequestSchema)` to create a new message.
 */
export const SetAccountLockRequestSchema: GenMessage<SetAccountLockRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 21);

/**
 * SetAccountLockResponse — handler output. Returns the post-write
 * snapshot of the caller's user-level lock state. The per-station
 * SessionPlayer projections are not returned here because the player
 * may be in multiple stations; subscribers reading
 * StreamSessionState / StreamPlayerState on each affected station
 * receive the per-station SessionPlayer with the new lock_status via
 * the SESSION_LOCK_STATUS_CHANGED / PLAYER_LOCK_STATUS_CHANGED
 * publishes.
 *
 * @generated from message evenplay.bay_session.v1.SetAccountLockResponse
 */
export type SetAccountLockResponse = Message<"evenplay.bay_session.v1.SetAccountLockResponse"> & {
  /**
   * Echo of the persisted smg_user_details.locked value (the value
   * the row carries after the write commits, identical to req.locked
   * on a fresh write; identical to the prior value on the no-op
   * idempotent path).
   *
   * @generated from field: bool locked = 1;
   */
  locked: boolean;

  /**
   * Whether this response is the result of a no-op idempotent path
   * (current state already matched req.locked, no rows were written)
   * versus a fresh write. Surfaces the dedupe outcome so clients can
   * correlate retries in logs.
   *
   * @generated from field: bool was_idempotent_replay = 2;
   */
  wasIdempotentReplay: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.SetAccountLockResponse.
 * Use `create(SetAccountLockResponseSchema)` to create a new message.
 */
export const SetAccountLockResponseSchema: GenMessage<SetAccountLockResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 22);

/**
 * ConfirmReadyToSwingRequest — kiosk reports a successful auth
 * gesture; clear a self-clearable per-station lock_status. GUARDIAN_REQUIRED
 * and the independent simulator timeout gate are preserved.
 *
 * @generated from message evenplay.bay_session.v1.ConfirmReadyToSwingRequest
 */
export type ConfirmReadyToSwingRequest = Message<"evenplay.bay_session.v1.ConfirmReadyToSwingRequest"> & {
  /**
   * Station hosting the player. Used for the roster check (the caller
   * must be a member of the station) and as the row key for the
   * lock_status write.
   *
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * Client-supplied idempotency key (UUID v4 string). Optional. Same
   * semantics as SetAccountLockRequest.idempotency_key — the
   * canonical dedupe is the post-condition (no self-clearable lock_status is
   * engaged); the key is informational and NOT persisted.
   *
   * @generated from field: string idempotency_key = 2;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.ConfirmReadyToSwingRequest.
 * Use `create(ConfirmReadyToSwingRequestSchema)` to create a new message.
 */
export const ConfirmReadyToSwingRequestSchema: GenMessage<ConfirmReadyToSwingRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 23);

/**
 * ConfirmReadyToSwingResponse — handler output. Returns the post-
 * write SessionPlayer + SessionState snapshot so the caller can
 * verify the gate state without a second GetSessionState round-trip.
 *
 * @generated from message evenplay.bay_session.v1.ConfirmReadyToSwingResponse
 */
export type ConfirmReadyToSwingResponse = Message<"evenplay.bay_session.v1.ConfirmReadyToSwingResponse"> & {
  /**
   * The caller's post-write SessionPlayer. A self-clearable lock_status is
   * ACTIVE after a fresh write; GUARDIAN_REQUIRED and timeout-derived is_idle
   * are preserved on their no-op paths.
   *
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 1;
   */
  player?: SessionPlayer;

  /**
   * The post-write SessionState snapshot for the addressed station.
   *
   * @generated from field: evenplay.bay_session.v1.SessionState session = 2;
   */
  session?: SessionState;

  /**
   * Whether this response is the result of a no-op idempotent path
   * (no self-clearable lock_status was engaged) versus a fresh write. Surfaces
   * the dedupe outcome so clients can correlate retries in logs.
   *
   * @generated from field: bool was_idempotent_replay = 3;
   */
  wasIdempotentReplay: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.ConfirmReadyToSwingResponse.
 * Use `create(ConfirmReadyToSwingResponseSchema)` to create a new message.
 */
export const ConfirmReadyToSwingResponseSchema: GenMessage<ConfirmReadyToSwingResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 24);

/**
 * RecordGuardianAcknowledgementRequest — the guardian's
 * acknowledgement gesture on behalf of a Junior. The calling player's
 * JWT identifies the guardian (no guardian_user_id field).
 * SMG-3170 (v1.1 G2.5).
 *
 * @generated from message evenplay.bay_session.v1.RecordGuardianAcknowledgementRequest
 */
export type RecordGuardianAcknowledgementRequest = Message<"evenplay.bay_session.v1.RecordGuardianAcknowledgementRequest"> & {
  /**
   * The Junior player whose bay_session_players.lock_status is
   * being cleared. Must be a roster member of station_id and have
   * tier == JUNIOR; otherwise the handler returns
   * CodeFailedPrecondition with ErrTargetNotJunior.
   *
   * @generated from field: int64 junior_user_id = 1;
   */
  juniorUserId: bigint;

  /**
   * Station the acknowledgement is anchored to (must be > 0). The
   * lock_status flip is per-(junior_user_id, station_id); a Junior
   * who joins a second bay later needs a fresh acknowledgement at
   * that bay.
   *
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;

  /**
   * Client-supplied idempotency key (UUID v4 string). REQUIRED — no
   * compat-mode escape; this RPC is brand new. The key is persisted
   * on the audit row (smg_guardian_acknowledgement.idempotency_key
   * UNIQUE), so a retry with the same key returns the original
   * (acknowledgement_id, acknowledged_at) and produces NO new audit
   * row. When supplied, the version field MUST be 4 — the server
   * rejects v1/v3/v5 with CodeInvalidArgument.
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.RecordGuardianAcknowledgementRequest.
 * Use `create(RecordGuardianAcknowledgementRequestSchema)` to create a new message.
 */
export const RecordGuardianAcknowledgementRequestSchema: GenMessage<RecordGuardianAcknowledgementRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 25);

/**
 * RecordGuardianAcknowledgementResponse — handler output. Returns
 * the durable audit-row identity so the caller can correlate
 * gestures across retries.
 *
 * @generated from message evenplay.bay_session.v1.RecordGuardianAcknowledgementResponse
 */
export type RecordGuardianAcknowledgementResponse = Message<"evenplay.bay_session.v1.RecordGuardianAcknowledgementResponse"> & {
  /**
   * smg_guardian_acknowledgement.id of the audit row that recorded
   * this gesture. Stable across idempotent replays — the same key
   * returns the same id. String-form of the BIGSERIAL PK for wire
   * stability across the future int64→UUID migration.
   *
   * @generated from field: string acknowledgement_id = 1;
   */
  acknowledgementId: string;

  /**
   * smg_guardian_acknowledgement.acknowledged_at — the wall-clock
   * the audit row was first inserted. RFC3339 string. Stable across
   * idempotent replays.
   *
   * @generated from field: string acknowledged_at = 2;
   */
  acknowledgedAt: string;

  /**
   * Whether this response is the result of an idempotent replay
   * (true; key matched an existing audit row, no new row written,
   * lock_status flip skipped) versus a fresh acknowledgement
   * (false). Surfaces the dedupe path so clients can correlate
   * retries in logs.
   *
   * @generated from field: bool was_idempotent_replay = 3;
   */
  wasIdempotentReplay: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.RecordGuardianAcknowledgementResponse.
 * Use `create(RecordGuardianAcknowledgementResponseSchema)` to create a new message.
 */
export const RecordGuardianAcknowledgementResponseSchema: GenMessage<RecordGuardianAcknowledgementResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 26);

/**
 * TopGolfBayCheckInRequest — request body for the TopGolfBayCheckIn
 * RPC. The TopGolf bay JWT travels in the body field (NOT the
 * Authorization header) so the player-listener's authz interceptor
 * (which expects evenplay-issued tokens) does not reject the inbound
 * request. The handler runs its own JWKS-backed verification on
 * `topgolf_jwt` before issuing an evenplay player JWT.
 *
 * @generated from message evenplay.bay_session.v1.TopGolfBayCheckInRequest
 */
export type TopGolfBayCheckInRequest = Message<"evenplay.bay_session.v1.TopGolfBayCheckInRequest"> & {
  /**
   * Raw TopGolf bay JWT (RS256, RFC 7519). Required. Carries the
   * bay_uuid, venue_id, country / state / city, and sub claims the
   * handler resolves into the bay-session entry.
   *
   * @generated from field: string topgolf_jwt = 1;
   */
  topgolfJwt: string;

  /**
   * Skip the in-app confirmation step for the implicit JoinSession.
   * Default false. Forwarded to JoinSession's bypass_confirmation
   * field.
   *
   * @generated from field: bool bypass_confirmation = 2;
   */
  bypassConfirmation: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.TopGolfBayCheckInRequest.
 * Use `create(TopGolfBayCheckInRequestSchema)` to create a new message.
 */
export const TopGolfBayCheckInRequestSchema: GenMessage<TopGolfBayCheckInRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 27);

/**
 * TopGolfBayCheckInResponse — handler output. Carries the freshly-
 * minted evenplay player JWT, the resolved smg_user.user_id, the
 * station_id the player joined, and the post-join SessionPlayer +
 * SessionState snapshots.
 *
 * @generated from message evenplay.bay_session.v1.TopGolfBayCheckInResponse
 */
export type TopGolfBayCheckInResponse = Message<"evenplay.bay_session.v1.TopGolfBayCheckInResponse"> & {
  /**
   * Freshly-minted evenplay player JWT (HS256, AuthMethod="topgolf",
   * KYCStatus=0). Caller forwards this on subsequent
   * BaySessionService RPCs in the Authorization: Bearer header.
   *
   * @generated from field: string evenplay_jwt = 1;
   */
  evenplayJwt: string;

  /**
   * The resolved smg_user.user_id as a decimal string. Surfaced so
   * the client can correlate without re-decoding the JWT.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * The legacy BIGINT station_id the player was joined to. Surfaced
   * so the client knows which bay it landed in (and can use it as the
   * station_id field on subsequent player-listener RPCs).
   *
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * Post-join SessionPlayer snapshot — the joining player's row in
   * the bay session. Same shape JoinSession returns.
   *
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 4;
   */
  player?: SessionPlayer;

  /**
   * Post-join SessionState snapshot — the bay's full roster + state
   * after the implicit join. Same shape JoinSession returns.
   *
   * @generated from field: evenplay.bay_session.v1.SessionState session = 5;
   */
  session?: SessionState;

  /**
   * Snapshot of smg_user_details.kyc_status surfaced via smg-core's
   * UpsertUser reply (qb.smg.User.kyc_status, field 20). Values:
   *   0 = not attempted
   *   1 = passed
   *   2 = failed
   *
   * Same semantics as FullSwingAuthResponse.kyc_status. A freshly-
   * provisioned TopGolf user starts at 0; an existing TopGolf user who
   * completed KYC out-of-band carries the persisted value.
   *
   * See docs/partners/integration.md section 2 for the tier
   * derivation model and the server-side helper in
   * apps/platform-domain/bay-session/internal/eligibility/.
   *
   * @generated from field: int32 kyc_status = 6;
   */
  kycStatus: number;
};

/**
 * Describes the message evenplay.bay_session.v1.TopGolfBayCheckInResponse.
 * Use `create(TopGolfBayCheckInResponseSchema)` to create a new message.
 */
export const TopGolfBayCheckInResponseSchema: GenMessage<TopGolfBayCheckInResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 28);

/**
 * EvenPlayAuthRequest — request body for the EvenPlayAuth RPC. The
 * native credential travels in the body (NOT the Authorization header)
 * so the player-listener's authz interceptor (which expects evenplay-
 * issued tokens) does not reject the inbound request; the handler
 * forwards the credential to core for verification.
 *
 * @generated from message evenplay.bay_session.v1.EvenPlayAuthRequest
 */
export type EvenPlayAuthRequest = Message<"evenplay.bay_session.v1.EvenPlayAuthRequest"> & {
  /**
   * The player's native login credential — exactly one of OTP or facial
   * recognition. Both are native auth_methods (not prefixed partner_),
   * so the resulting player JWT is admitted by the player-listener gate.
   *
   * @generated from oneof evenplay.bay_session.v1.EvenPlayAuthRequest.credential
   */
  credential: {
    /**
     * @generated from field: evenplay.bay_session.v1.OtpCredential otp = 1;
     */
    value: OtpCredential;
    case: "otp";
  } | {
    /**
     * @generated from field: evenplay.bay_session.v1.ImageCredential image = 2;
     */
    value: ImageCredential;
    case: "image";
  } | { case: undefined; value?: undefined };

  /**
   * The bay session to check into. Exact-match against
   * bay_session_state.session_id; resolved to a station_id for the
   * implicit join. NotFound when there is no active session for it.
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * Optional. Controls the returned redirect_target, mirroring
   * FullSwingAuthRequest.promo_type semantics.
   *
   * @generated from field: string promo_type = 4;
   */
  promoType: string;

  /**
   * Optional client-supplied key. RESERVED for future retry-safe deferred
   * OTP consume (SMG-3592) — NOT yet consumed by the handler. The OTP is
   * consumed at verify time, so a retry after a downstream (join) failure
   * currently requires a fresh code; this key does not yet make check-in
   * retry-safe.
   *
   * @generated from field: string idempotency_key = 5;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.EvenPlayAuthRequest.
 * Use `create(EvenPlayAuthRequestSchema)` to create a new message.
 */
export const EvenPlayAuthRequestSchema: GenMessage<EvenPlayAuthRequest> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 29);

/**
 * OtpCredential — one-time-passcode login identifier + code. The
 * contact oneof carries whichever channel the OTP was requested on
 * (email or SMS); otp_code is the 6-digit code the user entered. Step 1
 * (RequestOtpCode, which sends the code) is a separate public
 * SmgService RPC the client calls directly.
 *
 * @generated from message evenplay.bay_session.v1.OtpCredential
 */
export type OtpCredential = Message<"evenplay.bay_session.v1.OtpCredential"> & {
  /**
   * @generated from oneof evenplay.bay_session.v1.OtpCredential.contact
   */
  contact: {
    /**
     * @generated from field: string email_address = 1;
     */
    value: string;
    case: "emailAddress";
  } | {
    /**
     * @generated from field: string phone_number = 2;
     */
    value: string;
    case: "phoneNumber";
  } | { case: undefined; value?: undefined };

  /**
   * Never logged.
   *
   * @generated from field: string otp_code = 3;
   */
  otpCode: string;
};

/**
 * Describes the message evenplay.bay_session.v1.OtpCredential.
 * Use `create(OtpCredentialSchema)` to create a new message.
 */
export const OtpCredentialSchema: GenMessage<OtpCredential> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 30);

/**
 * ImageCredential — facial-recognition login. Raw captured image bytes;
 * never logged. Fail-closed at verification (no match → error, never a
 * default user).
 *
 * @generated from message evenplay.bay_session.v1.ImageCredential
 */
export type ImageCredential = Message<"evenplay.bay_session.v1.ImageCredential"> & {
  /**
   * @generated from field: bytes image = 1;
   */
  image: Uint8Array;
};

/**
 * Describes the message evenplay.bay_session.v1.ImageCredential.
 * Use `create(ImageCredentialSchema)` to create a new message.
 */
export const ImageCredentialSchema: GenMessage<ImageCredential> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 31);

/**
 * EvenPlayAuthResponse — handler output. Mirrors FullSwingAuthResponse:
 * the freshly-minted evenplay player JWT, the resolved user_id, the
 * T&C / KYC gate snapshots (surfaced so the client can route to the
 * gate before play), the redirect target, and the smg-core session
 * token the client uses for smgClient.* RPCs.
 *
 * @generated from message evenplay.bay_session.v1.EvenPlayAuthResponse
 */
export type EvenPlayAuthResponse = Message<"evenplay.bay_session.v1.EvenPlayAuthResponse"> & {
  /**
   * Freshly-minted evenplay player JWT (HS256, AuthMethod "otp"|"image").
   * Never logged.
   *
   * @generated from field: string evenplay_jwt = 1;
   */
  evenplayJwt: string;

  /**
   * The resolved smg_user.user_id as a decimal string.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * Snapshot of smg_user_details.tnc_accepted at handler-run time.
   *
   * @generated from field: bool tnc_accepted = 3;
   */
  tncAccepted: boolean;

  /**
   * Where the client should navigate after auth (from promo_type).
   *
   * @generated from field: string redirect_target = 4;
   */
  redirectTarget: string;

  /**
   * smg-core-issued session token. An empty value is a hard auth
   * failure, matching FullSwing's contract. Never logged.
   *
   * @generated from field: string smg_session_token = 5;
   */
  smgSessionToken: string;

  /**
   * User-shape fields the client needs immediately post-auth.
   *
   * @generated from field: string first_name = 6;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 7;
   */
  lastName: string;

  /**
   * Never logged.
   *
   * YYYY-MM-DD; empty when core has no value
   *
   * @generated from field: string date_of_birth = 8;
   */
  dateOfBirth: string;

  /**
   * Snapshot of smg_user_details.kyc_status (0=not attempted, 1=passed,
   * 2=failed). Same semantics as FullSwingAuthResponse.kyc_status.
   *
   * @generated from field: int32 kyc_status = 9;
   */
  kycStatus: number;
};

/**
 * Describes the message evenplay.bay_session.v1.EvenPlayAuthResponse.
 * Use `create(EvenPlayAuthResponseSchema)` to create a new message.
 */
export const EvenPlayAuthResponseSchema: GenMessage<EvenPlayAuthResponse> = /*@__PURE__*/
  messageDesc(file_player_bay_session, 32);

/**
 * ── Session lifecycle (player side) ─────────────────────────────────────
 *
 * @generated from service evenplay.bay_session.v1.PlayerBaySessionService
 */
export const PlayerBaySessionService: GenService<{
  /**
   * JoinSession — add the calling player to the bay session.
   * Predicate: RequirePlayerSelf — the token's user_id is the player who
   * is joining. The request body's station_id identifies the bay.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.JoinSession
   */
  joinSession: {
    methodKind: "unary";
    input: typeof JoinSessionRequestSchema;
    output: typeof JoinSessionResponseSchema;
  },
  /**
   * AcceptBet — player accepts a wager on a specific challenge.
   * Predicate: RequirePlayerSelf — the token's user_id is the bettor.
   *
   * Creates an smg_bet row in state 'accepted' with no wallet operation;
   * funds are locked at StartHit (deferred-commit per spec §2.4). The four
   * idempotency-key fields (accept/debit/payout/refund) are persisted on
   * the row so StartHit / ProcessShot / refund paths can forward them to
   * the wallet's dedupe layer.
   *
   * Idempotency contract: same (user, accept_idempotency_key,
   * accept_request_hash) returns the existing bet; same key + different
   * hash returns CodeFailedPrecondition (idempotency-conflict). See spec
   * §12.2 and the Stripe-style verify note.
   *
   * Free-bet semantics: an old `bool free_bet` field (field number 5)
   * was removed before BSA shipped — it was client-controlled with no
   * entitlement check and is therefore a free-money exploit surface.
   * The server now writes smg_bet.free_bet=FALSE unconditionally on
   * this path. Future free-bet support will be capability-based (a
   * server-resolved entitlement grant), not an ambient client bool.
   * See AcceptBetRequest's `reserved 5` note for the full contract.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.AcceptBet
   */
  acceptBet: {
    methodKind: "unary";
    input: typeof AcceptBetRequestSchema;
    output: typeof AcceptBetResponseSchema;
  },
  /**
   * CancelBet — player-initiated cancellation of an ACCEPTED bet.
   * Predicate: RequirePlayerSelf — the token's user_id MUST own the bet.
   * Ownership is validated AFTER the bet lookup (the request carries
   * bet_id, not user_id; the handler reads the bet row, compares the
   * bet's user_id to the token's resolved smg_user.user_id, and rejects
   * with CodePermissionDenied if they differ).
   *
   * No wallet operation: deferred-commit per spec §2.4 means an
   * ACCEPTED bet has no debit yet, so the bet row's bet_state flips to
   * 'refunded' with NO wallet RPC — Service.ConfirmRefund handles the
   * short-circuit branch internally for the BetStateAccepted case
   * (returns nil without calling the wallet).
   *
   * State preconditions:
   *
   *   - bet_state == 'accepted' → flip to 'refunded' with
   *     refund_reason='player_cancelled' (happy path).
   *   - bet_state == 'refunded' AND refund_reason == 'player_cancelled'
   *     → idempotent replay (returns the existing refund as-is with
   *     was_idempotent_replay=true).
   *   - bet_state in {'committed','settling','closed','recovery_failed'}
   *     → CodeFailedPrecondition (admin path only — the wallet has
   *     been told to debit or the bet has been settled, or the
   *     recovery worker flagged the bet for operator review).
   *   - bet_state == 'refunded' with refund_reason != 'player_cancelled'
   *     → CodeFailedPrecondition (do not overwrite a non-player-cancel
   *     refund reason, e.g. 'player_removed' from the RemovePlayer
   *     cascade).
   *
   * Idempotency: the idempotency_key is informational at the wire
   * surface — the canonical state is the bet row's bet_state +
   * refund_reason. A retry with the same (bet_id, idempotency_key)
   * against an already-cancelled-by-player bet returns the existing
   * refund response with was_idempotent_replay=true. The key is
   * required (no compat-mode escape — CancelBet is a post-AcceptBet
   * RPC that did not exist before the BSA cutover, so legacy clients
   * never call it).
   *
   * Spec §2.4 + §15.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.CancelBet
   */
  cancelBet: {
    methodKind: "unary";
    input: typeof CancelBetRequestSchema;
    output: typeof CancelBetResponseSchema;
  },
  /**
   * ResizeWager — player changes the amount of an open wager without
   * cancel+recreate (SMG-3140 v1.1 B4). NO wallet call is made: the
   * deferred-commit invariant (BSA-5-2) means the wallet's BET ledger row
   * does not yet exist for an 'accepted' state bet. StartHit's ConfirmDebit
   * fires the wallet's Bet RPC with smg_bet.amount when it runs, so the new
   * amount lands at the wallet there.
   *
   * Two routes (SMG-3488, mirroring ProcessShot's split):
   *   - MATCHED: a bay_session_wagers row exists at (caller, station_id,
   *     currency). The handler updates BOTH bay_session_wagers.amount and
   *     smg_bet.amount inside one MutateStation tx.
   *   - LEGACY: no wager row — the FullSwing autoplay accept path (SMG-3065)
   *     leaves smg_bet.station_id NULL and no wager mirror. The handler
   *     resolves the station's active bet (anchoring-OR-roster) and updates
   *     smg_bet.amount only; NO bay_session_wagers row is written.
   *
   * Pre-flight:
   *   - The resolved bet must be in bet_state='accepted'. Committed /
   *     settling / closed bets are past the deferred-commit window; the
   *     wallet has been debited (or is in flight) and resizing would race
   *     the lifecycle.
   *   - new_amount must be > 0 (a zero amount is a CancelBet, not a resize).
   *   - On grow (new_amount > current): the available_to_bet projection
   *     (BSA-6-3) is checked against the DELTA between current and new
   *     amount; insufficient funds → CodeFailedPrecondition with
   *     ErrAmountExceedsBalance.
   *
   * Admission gates enforce what each route's ACCEPT path enforced
   * (SMG-3488 iter-3): BOTH routes run the walkaway-protection lock gate.
   * The MATCHED route ALSO runs the tier + real-money-capability gates
   * (bay-session-native accept ran them). The LEGACY route does NOT — the
   * engine accepts the FullSwing bet as USD and bypasses those gates, so a
   * legacy bet can legitimately exist at a non-real-money-capable bay;
   * re-imposing the capability gate only at resize would make the
   * shot-amount change impossible for that live case.
   *
   * Idempotency / repeat semantics (SMG-3488): ResizeWager sets an ABSOLUTE
   * amount and makes no wallet call, so it is naturally idempotent. The
   * idempotency_key is OPTIONAL; when supplied it is recorded on the
   * bay_session_wagers row (matched route) purely as an audit breadcrumb.
   * Multiple resizes are allowed with LAST-WRITE-WINS — there is no
   * one-resize-per-bet constraint and no same-key/different-body conflict. A
   * same-amount call is a clean no-op. was_idempotent_replay is retained on
   * the response for wire compatibility but is always false.
   *
   * Predicate: RequirePlayerSelf — the token's user_id is the wager
   * owner. Cross-player resize is not a supported operation.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.ResizeWager
   */
  resizeWager: {
    methodKind: "unary";
    input: typeof ResizeWagerRequestSchema;
    output: typeof ResizeWagerResponseSchema;
  },
  /**
   * LeaveSession — player-initiated checkout.
   * Predicate (dual): RequirePlayerSelf on this listener;
   * SimulatorBaySessionService's listener uses RequireSimulatorForStation.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.LeaveSession
   */
  leaveSession: {
    methodKind: "unary";
    input: typeof LeaveSessionRequestSchema;
    output: typeof LeaveSessionResponseSchema;
  },
  /**
   * GetSessionState — snapshot of current session state for a station.
   * Predicate (dual): RequireSimulatorOrPlayerForSession — a player can
   * read the state of any station they are a member of.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.GetSessionState
   */
  getSessionState: {
    methodKind: "unary";
    input: typeof GetSessionStateRequestSchema;
    output: typeof GetSessionStateResponseSchema;
  },
  /**
   * StreamSessionState — real-time session updates for a station.
   * Predicate (dual): RequireSimulatorOrPlayerForSession.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.StreamSessionState
   */
  streamSessionState: {
    methodKind: "server_streaming";
    input: typeof StreamSessionStateRequestSchema;
    output: typeof SessionStateUpdateSchema;
  },
  /**
   * GetBetDetails — single-shot fetch of the canonical challenges +
   * paylines + bet identity for a bet_id. Replaces the burrito-side
   * smg.GetGameState dependency for payout-ring rendering and local
   * shot-result calculation (BSA-FU-GETGAMESTATE-RPC).
   * Predicate (dual): RequireSimulatorOrPlayerForSession against the
   * bet's owning station_id. Same semantics as GetSessionState — any
   * roster member may read any bet hosted on their bay.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.GetBetDetails
   */
  getBetDetails: {
    methodKind: "unary";
    input: typeof GetBetDetailsRequestSchema;
    output: typeof GetBetDetailsResponseSchema;
  },
  /**
   * StreamPlayerState — real-time per-user updates (mobile app).
   * Predicate: RequirePlayerSelf — privacy boundary: a player sees only
   * their own state, never another player's.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.StreamPlayerState
   */
  streamPlayerState: {
    methodKind: "server_streaming";
    input: typeof StreamPlayerStateRequestSchema;
    output: typeof PlayerStateUpdateSchema;
  },
  /**
   * SetPlayerConfirmationSettings — player updates their own confirmation
   * preferences.
   * Predicate (dual): RequirePlayerSelf on this listener;
   * SimulatorBaySessionService's listener uses RequireSimulatorForStation.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.SetPlayerConfirmationSettings
   */
  setPlayerConfirmationSettings: {
    methodKind: "unary";
    input: typeof SetPlayerConfirmationSettingsRequestSchema;
    output: typeof SetPlayerConfirmationSettingsResponseSchema;
  },
  /**
   * RespondToConfirmation — player accepts or declines their turn/shot
   * prompt.
   * Predicate: RequirePlayerSelf.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.RespondToConfirmation
   */
  respondToConfirmation: {
    methodKind: "unary";
    input: typeof RespondToConfirmationRequestSchema;
    output: typeof RespondToConfirmationResponseSchema;
  },
  /**
   * AckMessage — acknowledge a notification message currently active in
   * this bay (SMG-3330). Dual-hosted (also on SimulatorBaySessionService,
   * message types in bay_session_shared.proto): the PLAYER side serves
   * mobile — the caller may ack only messages on their OWN active list
   * (player-targeted or broadcast). bay-session authorizes the caller,
   * then forwards the ack to NotificationService (the authoritative
   * store) before returning; the updated active_messages projection
   * arrives on the caller's existing PlayerState stream. Scope is NEVER
   * taken from the request (only message_id is supplied), so a caller
   * cannot widen its own authorization.
   * Predicate: RequirePlayerSelf + ownership via the pod's projection.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.AckMessage
   */
  ackMessage: {
    methodKind: "unary";
    input: typeof AckMessageRequestSchema;
    output: typeof AckMessageResponseSchema;
  },
  /**
   * SkipMyTurn — kiosk user opts out of their next scheduled rotation
   * turn.
   * Predicate: RequirePlayerSelf.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.SkipMyTurn
   */
  skipMyTurn: {
    methodKind: "unary";
    input: typeof SkipMyTurnRequestSchema;
    output: typeof SkipMyTurnResponseSchema;
  },
  /**
   * SetWagerMode — caller chooses their own per-player wager CATEGORY
   * for upcoming wagers (NONE / MONEY / POINTS / PRACTICE; SMG-3087).
   * Predicate: RequirePlayerSelf — the token's user_id is the player
   * whose bay_session_players.wager_mode is being mutated; no user_id
   * field is exposed on the request, the int64 smg_user.user_id is
   * bridged server-side from claims.UserID via UserLookup.
   *
   * Promotes the test-only-tools /bay-session/set-player-wager-mode
   * endpoint (LIVE-PW-7 follow-up): production needs a real player-
   * authenticated path because the FullSwingAuth/JoinSession default
   * of WAGER_MODE_NONE leaves the player paused (rotation chain-skip
   * treats wager_mode='NONE' as inactive). The player picks Real
   * Money vs Partner Points before placing their first bet via this
   * RPC; the specific wallet currency (USD vs TGPTS vs FSPTS) is
   * resolved server-side from venue_partner config at AcceptBet time.
   *
   * Vocabulary: the proto WagerMode enum is the wire surface
   * (NONE / MONEY / POINTS / PRACTICE — the SMG-3087 category
   * vocabulary; partner-specific points tokens were collapsed onto
   * POINTS). Out-of-vocabulary numeric values that arrive on the
   * wire (proto3 enums accept any int32 by default) are rejected
   * with CodeInvalidArgument so an unknown enum value cannot
   * silently collapse to WAGER_MODE_NONE and pause the caller.
   * WAGER_MODE_NONE is itself a meaningful choice — it leaves the
   * player paused (effectively spectating) until another
   * SetWagerMode call promotes them.
   *
   * Mode-agnostic. Setting the same value already on the row is a
   * no-op success (NO publish, returns the current player snapshot
   * unchanged) — the row's updated_at watermark is not advanced.
   *
   * Publish reasons: SESSION_WAGER_MODE_CHANGED on the station fan-out
   * and PLAYER_WAGER_MODE_CHANGED on the per-user channel. When the
   * change moves the currently-active player into WAGER_MODE_NONE
   * (the active slot becomes paused), the reasons switch to
   * SESSION_PLAYER_WAGER_MODE_NONE / PLAYER_WAGER_MODE_NONE so
   * subscribers see the "active became paused" wire signal that the
   * existing rotation chain-skip publishers already emit. The next
   * rotation-advance read will chain-skip the now-paused active
   * player; that cascade is intentionally NOT performed inline here
   * to keep this RPC's mutation scope to a single row.
   *
   * Errors:
   *   - CodeInvalidArgument: station_id <= 0, or wager_mode is an
   *     out-of-vocabulary numeric enum value.
   *   - CodeNotFound: caller's user is not in the station's roster
   *     (must JoinSession first; ErrPlayerNotInRoster).
   *   - CodePermissionDenied: claims missing user_id, partner-mode
   *     auth_method, or wrong principal kind (interceptor + predicate
   *     pre-check).
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.SetWagerMode
   */
  setWagerMode: {
    methodKind: "unary";
    input: typeof SetWagerModeRequestSchema;
    output: typeof SetWagerModeResponseSchema;
  },
  /**
   * SetNextWagerCurrency — caller picks the wallet CURRENCY (the wallet
   * token: USD / TGPTS / FSPTS / PRACTICE) their next wager will draw
   * from, and the server derives the matching wager_mode CATEGORY from
   * it. Where SetWagerMode chooses the coarse category (MONEY / POINTS /
   * PRACTICE — SMG-3087), this RPC pins the exact wallet token so a
   * player at a multi-currency venue (e.g. a partner that supports both
   * USD real-money and a partner points balance) can choose which
   * balance funds the bet.
   * Predicate: RequirePlayerSelf — the token's user_id is the player
   * whose bay_session_players.next_wager_currency is being mutated; no
   * user_id field is exposed on the request, the int64 smg_user.user_id
   * is bridged server-side from claims.UserID via UserLookup.
   *
   * Effect: writes bay_session_players.next_wager_currency = currency and
   * the derived bay_session_players.wager_mode (currency → category map
   * is venue_partner config, not proto vocabulary — see CLAUDE.md
   * "Bay-Session Wager Vocabulary"). Applies only to the NEXT, not-yet-
   * accepted wager; an already-accepted/committed bet keeps its own
   * currency (use SwitchWagerCurrency to re-mint an open one).
   *
   * Idempotency: idempotency_key is a client-supplied UUID v4. Setting
   * the same currency already on the row is a no-op success returning
   * the current player snapshot unchanged.
   *
   * SMG-3439: implemented — persists bay_session_players.next_wager_currency
   * and the derived wager_mode. An empty currency resolves to the station's
   * POINTS token (SMG-3452).
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.SetNextWagerCurrency
   */
  setNextWagerCurrency: {
    methodKind: "unary";
    input: typeof SetNextWagerCurrencyRequestSchema;
    output: typeof SetNextWagerCurrencyResponseSchema;
  },
  /**
   * SwitchWagerCurrency — change the currency of the caller's CURRENT
   * open wager by cancelling the existing bet and re-minting an
   * equivalent one in target_currency (the cancel+remint flow defined in
   * SMG-3443 / SMG-3444). Used when a player has already accepted a wager
   * in one currency and wants to move it to another (e.g. switch a USD
   * bet to a partner points balance) before swinging.
   * Predicate: RequirePlayerSelf — the target user is always the caller;
   * no user_id field on the request.
   *
   * Effect: cancels (refunds) the caller's open bet in its current
   * currency, then re-mints an equivalent wager in target_currency. The
   * response reports both the previous and new currency and whether a
   * re-mint actually occurred (reminted=false when the bet was already in
   * target_currency — a no-op success). Also updates
   * bay_session_players.next_wager_currency + derived wager_mode so
   * subsequent wagers follow the new selection.
   *
   * Idempotency: idempotency_key is a client-supplied UUID v4; a retry
   * with the same (caller, key) returns the existing re-mint result.
   *
   * SMG-3443/3444: implemented — cancels the open wager and re-mints an
   * equivalent one in target_currency in a single MutateStation tx
   * (points->USD applies a pre-arm funds-availability guard). An empty
   * target_currency resolves to the station's POINTS token (SMG-3452).
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.SwitchWagerCurrency
   */
  switchWagerCurrency: {
    methodKind: "unary";
    input: typeof SwitchWagerCurrencyRequestSchema;
    output: typeof SwitchWagerCurrencyResponseSchema;
  },
  /**
   * SetAutoContinue — toggle the caller's autoplay flag mid-session.
   * Predicate: RequirePlayerSelf — the target user is always the
   * caller (the player JWT carries it); no user_id field on the
   * request.
   *
   * Effect:
   *   - Writes auto_continue_enabled + (optional)
   *     auto_continue_wager_cents on bay_session_players for the
   *     caller's row at the supplied station.
   *   - Forwards to engine.EnableAutoPlay(user_id, wager_cents,
   *     enabled) so engine's autoplay-next-bet machinery picks up
   *     the change immediately. Engine is the source of truth for
   *     whether the NEXT bet auto-mints; bay-session's column is the
   *     local-station projection that SessionPlayer surfaces.
   *
   * Default state on JoinSession: enabled=TRUE,
   * wager_cents=NULL ("use last-played or engine default"). The
   * first explicit SetAutoContinue call is therefore typically an
   * OPT-OUT (enabled=false) or a wager-cents pin.
   *
   * Wager-cents semantics:
   *   - Pass wager_cents=0 to leave the per-user amount untouched
   *     (engine continues using last-played-or-default).
   *   - Pass wager_cents>0 to pin the autoplay amount to that
   *     value; engine stores it as the new per-user setting.
   *   - Negative values are rejected with CodeInvalidArgument.
   *
   * Idempotency: the same (enabled, wager_cents) tuple landing
   * twice is a no-op success. The handler reads-then-writes inside
   * the per-row tx so a concurrent toggle does not lose its update.
   *
   * Errors:
   *   - CodeInvalidArgument: station_id <= 0 or wager_cents < 0.
   *   - CodeNotFound: caller is not in the station's roster
   *     (must JoinSession first).
   *   - CodeInternal: engine.EnableAutoPlay returned a non-success
   *     payload — the local column write is rolled back so the two
   *     surfaces stay consistent.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.SetAutoContinue
   */
  setAutoContinue: {
    methodKind: "unary";
    input: typeof SetAutoContinueRequestSchema;
    output: typeof SetAutoContinueResponseSchema;
  },
  /**
   * FullSwingAuth — exchange a FullSwing-issued JWT for an evenplay
   * player JWT and check the player into a bay session. Public RPC
   * (no inbound evenplay token). The FullSwing JWT is carried in the
   * request body, not the Authorization header — the player-listener's
   * authz interceptor MUST bypass auth for this procedure via
   * PublicMethods so the inbound body-JWT does not trip the kind check
   * or player-token verification. The handler runs its own JWKS-backed
   * verification on the body field.
   *
   * Lookup-only path: returns CodeNotFound when the FullSwing principal
   * (partner_id=<full-swing>, partner_user_identifier=<cognito:username>)
   * has no matching smg_user row. A separate revision adds the
   * upsert / new-user path before the partner-service decommission.
   *
   * Idempotency: each call mints a fresh evenplay JWT (new jti, fresh
   * iat/exp); side effects deduplicate independently — smg_user
   * lookup is read-only, and the implicit JoinSession's already-joined
   * short-circuit handles the check-in retry.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.FullSwingAuth
   */
  fullSwingAuth: {
    methodKind: "unary";
    input: typeof FullSwingAuthRequestSchema;
    output: typeof FullSwingAuthResponseSchema;
  },
  /**
   * SetAccountLock — player toggles their persistent kiosk-walkaway-
   * protection opt-in. The persistent flag lives on
   * smg_user_details.locked (the user-level toggle), and a side effect
   * synchronously seeds bay_session_players.lock_status for every
   * active per-station row the user holds:
   *   locked=TRUE  -> lock_status = USER_LOCKED (gate engaged)
   *   locked=FALSE -> lock_status = ACTIVE      (gate clear)
   * Predicate: RequirePlayerSelf — the target is always the calling
   * player; no user_id field on the request.
   *
   * Idempotency: a same-state request (locked already matches) is a
   * no-op success — no row writes, no publishes, no updated_at bumps
   * on either the user_details row or the player rows. The optional
   * idempotency_key (UUID v4) is informational; the RPC's canonical
   * dedup is the post-condition (current state already matches).
   *
   * Cross-station scope: bay_session_players is updated via a single
   * multi-row UPDATE keyed by user_id (NOT scoped to a single
   * station). The cross-station fan-out matches the documented D3
   * eventually-consistent contract on smg_user_details.locked — a
   * concurrent ProcessShot reading the old value is admitted /
   * rejected per the prior policy, and the next shot observes the
   * new gate.
   *
   * Side effects post-commit:
   *   - Per-station SESSION_LOCK_STATUS_CHANGED on EVERY station the
   *     player is in (their lock_status flipped).
   *   - PLAYER_LOCK_STATUS_CHANGED on the caller's per-user channel.
   *
   * Errors:
   *   - CodePermissionDenied: claims missing user_id, partner-mode
   *     auth, or wrong principal kind.
   *   - CodeInvalidArgument: idempotency_key non-empty but not UUID v4.
   *   - CodeInternal: store / DB failure.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.SetAccountLock
   */
  setAccountLock: {
    methodKind: "unary";
    input: typeof SetAccountLockRequestSchema;
    output: typeof SetAccountLockResponseSchema;
  },
  /**
   * ConfirmReadyToSwing — kiosk reports a successful auth gesture
   * (biometric / PIN) on the mobile player's device. A self-clearable
   * bay_session_players.lock_status transitions to ACTIVE for
   * (caller, station), so the D3 readiness gate can admit the NEXT swing.
   * GUARDIAN_REQUIRED remains unchanged and requires the distinct guardian
   * acknowledgement flow. This gesture does not
   * clear the independent simulator timeout gate; only an explicit simulator
   * SetActivePlayer reactivation can do that. The
   * post-admit step (a future D3 follow-up that owns the
   * turn-boundary trigger) flips lock_status back to TURN_LOCKED
   * after the shot lands, preserving the single-shot semantic from
   * the ticket.
   *
   * Predicate: RequirePlayerSelf — the player has just re-auth'd on
   * their own device; the player JWT carries the auth-gesture
   * attestation. The "kiosk" in the mobile-flow description is the
   * skillstrike-mobile UI in partner mode (player principal), not
   * the simulator/burrito kiosk.
   *
   * Idempotency: a re-call when no self-clearable lock_status is engaged is a
   * no-op success — no row writes, no publishes, no updated_at bumps. This
   * includes both already-ACTIVE and GUARDIAN_REQUIRED rows. The optional
   * idempotency_key (UUID v4) is informational; the canonical dedup is the
   * post-condition.
   *
   * Side effects post-commit:
   *   - SESSION_LOCK_STATUS_CHANGED on the station subject.
   *   - PLAYER_LOCK_STATUS_CHANGED on the caller's per-user channel.
   *
   * Errors:
   *   - CodeInvalidArgument: station_id <= 0, or idempotency_key
   *     non-empty but not UUID v4.
   *   - CodePermissionDenied: claims missing user_id, partner-mode
   *     auth, or wrong principal kind.
   *   - CodeNotFound: caller is not in the station's roster.
   *   - CodeInternal: store / DB failure.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.ConfirmReadyToSwing
   */
  confirmReadyToSwing: {
    methodKind: "unary";
    input: typeof ConfirmReadyToSwingRequestSchema;
    output: typeof ConfirmReadyToSwingResponseSchema;
  },
  /**
   * RecordGuardianAcknowledgement — an authenticated guardian
   * (adult-tier player) acknowledges parental/guardian consent on
   * behalf of a JUNIOR-tier player at a specific station. Writes the
   * COPPA audit row (smg_guardian_acknowledgement, append-only) and
   * flips the Junior's bay_session_players.lock_status from
   * GUARDIAN_REQUIRED to ACTIVE so the D3 readiness gate admits
   * subsequent swings. SMG-3170 (v1.1 G2.5).
   *
   * Predicate: RequirePlayerSelf — the calling player's JWT
   * identifies the guardian; no guardian_user_id field on the
   * request. The target Junior is identified by junior_user_id; the
   * handler enforces that the caller's derived tier is adult
   * (UserTierAdultUnconfirmed or UserTierAdultKYCValidated; KYC-
   * failed adults are rejected to avoid endorsing a Junior account
   * via a flagged-adult endorsement) and that the target's tier is
   * JUNIOR.
   *
   * Audit-row write is unconditional on a fresh (non-replay) call —
   * the COPPA audit trail must capture every gesture even when the
   * operational side effect (lock_status flip) is a no-op because
   * the gate was already cleared by another path.
   *
   * Idempotency: key-based (NOT post-condition). The idempotency_key
   * is REQUIRED (no compat-mode escape; this RPC is brand new). A
   * retry with the same key returns the original (acknowledgement_id,
   * acknowledged_at) and was_idempotent_replay=true; NO new audit row
   * is written and NO lock_status flip is re-issued. Auditors can
   * therefore count distinct gestures by counting audit-row IDs.
   *
   * Side effects post-commit:
   *   - SESSION_LOCK_STATUS_CHANGED on the station subject (when the
   *     lock_status flip actually changed a row — same convention as
   *     ConfirmReadyToSwing's no-op-on-already-active branch).
   *   - PLAYER_LOCK_STATUS_CHANGED on the Junior's per-user channel.
   *
   * Errors:
   *   - CodeInvalidArgument: station_id <= 0, junior_user_id <= 0,
   *     missing or non-v4 idempotency_key.
   *   - CodeFailedPrecondition: caller's tier is not adult
   *     (ErrGuardianNotEligible), or target's tier is not JUNIOR
   *     (ErrTargetNotJunior), or target is not in the station's
   *     roster.
   *   - CodePermissionDenied: claims missing user_id, partner-mode
   *     auth, or wrong principal kind.
   *   - CodeInternal: store / DB failure.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.RecordGuardianAcknowledgement
   */
  recordGuardianAcknowledgement: {
    methodKind: "unary";
    input: typeof RecordGuardianAcknowledgementRequestSchema;
    output: typeof RecordGuardianAcknowledgementResponseSchema;
  },
  /**
   * TopGolfBayCheckIn — exchange a TopGolf bay JWT for an evenplay
   * player JWT and check the player into the bay's session. Public RPC
   * (no inbound evenplay token). The TopGolf bay JWT travels in the
   * request body, not the Authorization header — the player-listener's
   * authz interceptor MUST bypass auth for this procedure via
   * PublicMethods so the inbound body-JWT does not trip the kind check
   * or player-token verification. The handler runs its own JWKS-backed
   * verification on the body field.
   *
   * Resolution flow:
   *   1. Verify the inbound JWT against TopGolf's JWKS endpoint.
   *   2. Extract (sub, bay_uuid, venue_id, country, state, city).
   *   3. Resolve (bay_uuid → station UUID + legacy BIGINT station_id)
   *      via stations.partner_properties->>'topgolf_bay_uuid'.
   *   4. Resolve (venue_id, country, state, city) → venues row via
   *      venues.partner_properties->>'topgolf_venue_id' AND the
   *      country/state/city tuple match. Require a venue_partner row
   *      with partner_type='TOPGOLF'.
   *   5. Lookup-or-provision smg_user via smg-core's UpsertUser keyed
   *      on (partner_id=<topgolf>, partner_user_identifier=<sub>).
   *   6. Mint a fresh evenplay player JWT (AuthMethod="topgolf").
   *   7. Idempotent JoinSession against the resolved station_id
   *      (alreadyThere short-circuit absorbs retries).
   *
   * Idempotency: each call mints a fresh evenplay JWT (new jti, fresh
   * iat/exp); side effects deduplicate independently — the smg_user
   * upsert is idempotent on (partner_id, partner_user_identifier) and
   * the JoinSession step short-circuits on already-joined.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.TopGolfBayCheckIn
   */
  topGolfBayCheckIn: {
    methodKind: "unary";
    input: typeof TopGolfBayCheckInRequestSchema;
    output: typeof TopGolfBayCheckInResponseSchema;
  },
  /**
   * EvenPlayAuth — native evenplay player self-check-in. A plain
   * evenplay account (partner_id=0) authenticates with a one-time
   * passcode (OTP, by email or SMS) or facial recognition, receives a
   * freshly-minted evenplay player JWT + smg-core session token, and is
   * implicitly joined to the station's bay session. This is the native-
   * account analog of FullSwingAuth / TopGolfBayCheckIn — the player is
   * the actor throughout (distinct from AdminJoinPlayer, where staff
   * place another user). See docs/plans/2026-07-03-evenplay-native-auth.md.
   *
   * Public RPC (no inbound evenplay token). The credential travels in the
   * request body, not the Authorization header — the player-listener's
   * authz interceptor MUST bypass auth for this procedure via
   * PublicMethods so the inbound body-credential does not trip the kind
   * check or player-token verification. The credential itself is the
   * gate, as for FullSwing/TopGolf; the handler verifies it via core's
   * InternalApiService.AuthenticateNativeUser before minting anything.
   *
   * Ordering is load-bearing (§5 of the plan): credential verification +
   * session-token acquisition must succeed before the player JWT is
   * minted or the roster is touched, so a core failure never leaves a
   * usable JWT or a phantom roster row.
   *
   * Skeleton (EPA-S1): the RPC + messages define the wire contract only;
   * the handler is added in a later phase and initially returns
   * Unimplemented.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.EvenPlayAuth
   */
  evenPlayAuth: {
    methodKind: "unary";
    input: typeof EvenPlayAuthRequestSchema;
    output: typeof EvenPlayAuthResponseSchema;
  },
  /**
   * ListTournaments — browse available tournaments.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.ListTournaments
   */
  listTournaments: {
    methodKind: "unary";
    input: typeof ListTournamentRequestSchema;
    output: typeof ListTournamentReplySchema;
  },
  /**
   * ListDefaultTournaments — quick-access default tournaments.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.ListDefaultTournaments
   */
  listDefaultTournaments: {
    methodKind: "unary";
    input: typeof ListDefaultTournamentRequestSchema;
    output: typeof ListDefaultTournamentReplySchema;
  },
  /**
   * GetTournament — full detail for one tournament.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.GetTournament
   */
  getTournament: {
    methodKind: "unary";
    input: typeof GetTournamentRequestSchema;
    output: typeof GetTournamentReplySchema;
  },
  /**
   * JoinTournament — register the calling player.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.JoinTournament
   */
  joinTournament: {
    methodKind: "unary";
    input: typeof JoinTournamentRequestSchema;
    output: typeof JoinTournamentReplySchema;
  },
  /**
   * LeaveTournament — withdraw the calling player.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.LeaveTournament
   */
  leaveTournament: {
    methodKind: "unary";
    input: typeof LeaveTournamentRequestSchema;
    output: typeof LeaveTournamentReplySchema;
  },
  /**
   * GetTournamentLeaderBoard — ranked standings (dual; also on simulator).
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.GetTournamentLeaderBoard
   */
  getTournamentLeaderBoard: {
    methodKind: "unary";
    input: typeof GetTournamentLeaderBoardRequestSchema;
    output: typeof GetTournamentLeaderBoardReplySchema;
  },
  /**
   * GetTournamentPlayers — participant list (dual; also on simulator).
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.GetTournamentPlayers
   */
  getTournamentPlayers: {
    methodKind: "unary";
    input: typeof GetTournamentPlayersRequestSchema;
    output: typeof GetTournamentPlayersReplySchema;
  },
  /**
   * GetTournamentSchedule — level/series schedule.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.GetTournamentSchedule
   */
  getTournamentSchedule: {
    methodKind: "unary";
    input: typeof GetTournamentScheduleRequestSchema;
    output: typeof GetTournamentScheduleReplySchema;
  },
  /**
   * GetTournamentPrizeDistribution — prize table.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.GetTournamentPrizeDistribution
   */
  getTournamentPrizeDistribution: {
    methodKind: "unary";
    input: typeof GetTournamentPrizeDistributionRequestSchema;
    output: typeof GetTournamentPrizeDistributionReplySchema;
  },
  /**
   * CreatePrivateTournament — create a private tournament.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.CreatePrivateTournament
   */
  createPrivateTournament: {
    methodKind: "unary";
    input: typeof CreatePrivateTournamentRequestSchema;
    output: typeof CreatePrivateTournamentReplySchema;
  },
  /**
   * JoinPrivateTournament — join a private tournament by code.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.JoinPrivateTournament
   */
  joinPrivateTournament: {
    methodKind: "unary";
    input: typeof JoinPrivateTournamentRequestSchema;
    output: typeof JoinPrivateTournamentReplySchema;
  },
  /**
   * VerifyPrivateTournamentCode — validate a private code before joining.
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.VerifyPrivateTournamentCode
   */
  verifyPrivateTournamentCode: {
    methodKind: "unary";
    input: typeof VerifyPrivateTournamentCodeRequestSchema;
    output: typeof VerifyPrivateTournamentCodeReplySchema;
  },
  /**
   * StreamTournamentUpdates — live tournament/leaderboard updates (server stream).
   *
   * @generated from rpc evenplay.bay_session.v1.PlayerBaySessionService.StreamTournamentUpdates
   */
  streamTournamentUpdates: {
    methodKind: "server_streaming";
    input: typeof StreamTournamentUpdatesRequestSchema;
    output: typeof StreamTournamentUpdatesReplySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_player_bay_session, 0);

